@defer (when data) {
  <wcg-dialog [title]="data.title | titlecase" [size]="data.dialogSize">
    <div class="w-full invite-user-dialog__container" content>
      <form [formGroup]="inviteUserForm" novalidate>
        @let errorText =
          inviteUserForm.controls.email!.errors?.email
            ? "Enter a valid email"
            : "Email is Required";
        <wcg-input-field
          formControlName="email"
          label="Email"
          [errorText]="errorText"
          [isRequired]="true"
          (blurEvent)="checkIfEmailExists()"
        />
        @if (emailExists()) {
          <article class="w-full mb-8">
            <p class="invite-user-dialog__article-text">
              If the invitee is a new user, please enter their first and last
              name. For further assistance, contact the Client Care Team at
              ClientCare&#64;wcgclinical.com or 855-818-2289
            </p>
          </article>
          <div class="flex justify-between gap-4 w-full">
            @let fErrorText =
              inviteUserForm.controls.firstName.errors?.required
                ? "First name is required"
                : "";
            <wcg-input-field
              class="w-full"
              formControlName="firstName"
              label="First Name"
              [errorText]="fErrorText"
              [isRequired]="emailExists()"
            />
            @let lErrorText =
              inviteUserForm.controls.lastName.errors?.required
                ? "Last name is required"
                : "";
            <wcg-input-field
              class="w-full"
              formControlName="lastName"
              label="Last Name"
              [errorText]="lErrorText"
              [isRequired]="emailExists()"
            />
          </div>
        }
        @let hintText =
          organizationRoleHintMapper.get(
            inviteUserForm.controls.role.value?.label!.toLowerCase()
          ) ?? "";
        <wcg-uni-select
          class="block mt-8"
          formControlName="role"
          [options]="data.roles"
          label="Organization Role"
          [required]="true"
          errorText="Role is required"
          [hintText]="hintText"
        />
      </form>
    </div>

    <div tertiary>
      <wcg-button color="tertiary" (click)="close()"> Cancel</wcg-button>
    </div>

    <div primary>
      <wcg-button
        color="primary"
        (click)="data.callBacks.addUser(inviteUserForm.getRawValue())"
        [isDisabled]="inviteUserForm.invalid"
      >
        Add
      </wcg-button>
    </div>
  </wcg-dialog>
}
